'use client'
import { PageProviderServer } from './PageProvider'
// I had to static import this because the component was not being rendered fast enough
import Layout from 'components/LayoutAppRouter/Layout'
import HashFixer from '../../components/HashFixer/HashFixer'
import SetClientCookie from 'components/SetClientCookie/SetClientCookie'
import { DTIProvider } from 'providers/DTIProvider'
import { FeatureFlagProvider } from 'providers/FeatureFlagProvider'
import { AnalyticsProvider } from 'providers/AnalyticsProvider'
import { PhoneDataProvider } from 'providers/PhoneDataProvider'
import { GraduateProvider } from 'providers/GraduateProvider'
import { useAppRouter } from 'hooks/useAppRouter/useAppRouter'

export function PageProviderClient({ children, pageProps }: PageProviderServer) {
  const { dynamicPathname } = useAppRouter()
  const isFDRPage = pageProps.siteInfo?.url === 'https://www.freedomdebtrelief.com/'
  const printWebAppSchema = !isFDRPage
  const printLocalBusinessSchema = isFDRPage

  return (
    <>
      <HashFixer />
      <SetClientCookie cookies={pageProps?.cookiesToSet} />
      <AnalyticsProvider
        config={pageProps?.publicProcessDotEnv}
        pageVariation={pageProps?.pageVariation}
        pageSectionsVariations={pageProps?.pageSectionsVariations}
        loadEventProps={{
          ...(dynamicPathname === '/learn/[categoryname]/[slug]' && {
            content_type: pageProps?.content_type,
          }),
          ...(pageProps?.quiz_name && {
            quiz_name: pageProps?.quiz_name,
            quiz_page: pageProps?.quiz_page,
          }),
        }}
        siteEnv={pageProps?.publicProcessDotEnv?.NEXT_PUBLIC_SITE_ENVIRONMENT}
      >
        <FeatureFlagProvider
          // TODO: Where does featurePathOverrides come from? Its not being used anywhere from a search of the repo
          // Can we remove this functionality?
          featurePathOverrides={pageProps?.featurePathOverrides || {}}
          featureToggleObject={pageProps.featureToggleObject || {}}
        >
          <PhoneDataProvider
            phoneData={pageProps?.phoneData}
            phoneOverride={pageProps?.phoneOverride}
            associatedProduct={pageProps?.associatedProduct}
          >
            <GraduateProvider
              // TODO: Convert GraduateProvider to tsx
              initialState={pageProps?.graduate as unknown as null}
              initialHighlights={{
                largestDebtAmount: pageProps?.largestDebtAmount,
                fastestCompletion: pageProps?.fastestCompletion,
              }}
            >
              <Layout
                metaDescription={pageProps.metaDescription}
                pageMetaTitle={pageProps.pageMetaTitle}
                pageTitle={pageProps.pageTitle}
                canonicalLink={pageProps.canonicalLinkOverride || pageProps.canonicalUrlDefault}
                pageDisclosure={pageProps.pageDisclosure}
                secondaryDisclosures={pageProps.secondaryDisclosures}
                featureToggleObject={pageProps.featureToggleObject}
                isFFAMReferrer={pageProps.isFFAMReferrer}
                isMobileUA={pageProps.isMobileUA}
                ffamReferrerContent={pageProps.ffamReferrerContent}
                header={{
                  ...pageProps?.header,
                  siteEnv: pageProps.publicProcessDotEnv?.NEXT_PUBLIC_SITE_ENVIRONMENT,
                }}
                footer={pageProps?.footer}
                emergencyBanners={pageProps?.emergencyBanners || []}
                pageConfig={pageProps?.pageConfig}
                showHeader={!pageProps?.tcbBannerLayout}
                showFooter={!pageProps?.tcbBannerLayout}
                alignContentBottom={pageProps?.tcbBannerLayout}
                consentBanner={pageProps?.achieveConsentBanner?.[0] || []}
                specificHeaderCtaDataFiltered={pageProps.specificHeaderCtaDataFiltered}
                showPhoneNumber={pageProps?.showPhoneNumber}
                siteInfo={pageProps?.siteInfo}
                footerSticky={pageProps?.footerSticky}
                leadId={pageProps?.cookies?.['leadId']}
                printWebAppSchema={printWebAppSchema}
                printLocalBusinessSchema={printLocalBusinessSchema}
                associatedProduct={pageProps?.associatedProduct}
                publicProcessDotEnv={pageProps?.publicProcessDotEnv}
              >
                <DTIProvider>{children}</DTIProvider>
              </Layout>
            </GraduateProvider>
          </PhoneDataProvider>
        </FeatureFlagProvider>
      </AnalyticsProvider>
    </>
  )
}
